/**
 * Stable digest of pan/zoom-agnostic node positions for memo deps.
 * New object identity with unchanged coordinates maps to the same string.
 */

function qCoord(n) {
  if (!Number.isFinite(n)) return 'n';
  return String(Math.round(n));
}

/**
 * @param {Record<string, { x?: number, y?: number }>|null|undefined} positions
 * @returns {string}
 */
export function digestNodePositionsRecord(positions) {
  if (!positions) return '';
  const keys = Object.keys(positions);
  if (keys.length === 0) return '';
  keys.sort();
  const parts = new Array(keys.length);
  for (let i = 0; i < keys.length; i++) {
    const id = keys[i];
    const p = positions[id];
    if (!p || !Number.isFinite(p.x) || !Number.isFinite(p.y)) {
      parts[i] = `${id}:~`;
      continue;
    }
    parts[i] = `${id}:${qCoord(p.x)}:${qCoord(p.y)}`;
  }
  return parts.join('|');
}
